import React, { useRef } from "react"
import { useGLTF } from "@react-three/drei"
import { SpotLight } from "@react-three/drei"
import { MeshStandardMaterial } from "three"
import { VideoComponent } from "./VideoComponent"
import { useFrame } from "@react-three/fiber"
import TextComponent from "./TextComponent"

export function VideojuegosModel(props) {
  const { nodes, materials } = useGLTF("/generic_low-poly_arcade_cabinet(2).glb")
  const screen = useRef()

  const SpotlightComponent = () => {
    const ref = useRef()
    return (
      <SpotLight
        ref={ref}
        angle={1}
        penumbra={1}
        intensity={0.3}
        castShadow
        position={[3, -3, -5]}
        shadow-mapSize-width={1024}
        shadow-mapSize-height={1024}
        shadow-bias={-0.0001}
      />
    )
  }

  useFrame(() => {
    // console.log(screen.current.rotation)
  })

  const openNewTab = () => {
    window.open("https://demospaceball.vercel.app/", "_blank")
  }

  return (
    <group>
      <VideoComponent
        isMobile={props.isMobile}
        url="https://3d-flow-mintsite.vercel.app/"
        title="cyphers"
        idx={1}
        vid={"https://res.cloudinary.com/ddbgaessi/video/upload/v1674178128/Screencast_from_01-19-2023_07_24_35_PM_c5epfz.webm"}
        scale={0.46}
        position={[0, -0.56, 0.25]}
        rotation={[-0.3, 0, 0]}
        isVideogame
      />
        <TextComponent fs="0.03"  position={[0, -0.85, 0.4]} rotation={[0, 0, 0]} txt="presiona el botón para jugar" />

      <group {...props} dispose={null}>
        <SpotlightComponent />

        <mesh ref={screen} castShadow receiveShadow geometry={nodes.Object_4.geometry} material={materials["ArcadeScreen.001"]} />
        <mesh castShadow receiveShadow geometry={nodes.Object_5.geometry} material={materials.ArcadeButton1}  onClick={openNewTab} />
        <mesh castShadow receiveShadow geometry={nodes.Object_6.geometry} material={materials.ArcadeButton2} onClick={openNewTab} />
        <mesh castShadow receiveShadow geometry={nodes.Object_7.geometry} material={materials.ArcadeJoystick} />
        <mesh castShadow receiveShadow geometry={nodes.Object_8.geometry} material={materials.ArcadeScreen} />
        <mesh castShadow receiveShadow geometry={nodes.Object_9.geometry} material={materials.ArcadeSideLeft} />
        <mesh castShadow receiveShadow geometry={nodes.Object_10.geometry} material={materials.ArcadeSideLeft} />
        <mesh castShadow receiveShadow geometry={nodes.Object_11.geometry} material={materials.ArcadeSideLeft} />
        <mesh castShadow receiveShadow geometry={nodes.Object_12.geometry} material={materials.ArcadeControlBoard} />
      </group>
    </group>
  )
}

useGLTF.preload("/generic_low-poly_arcade_cabinet(2).glb")
